module.exports = __webpack_public_path__ + "static/media/head-side-medical.ac21dd5a.svg";